import { UnsuitableReasonUsageType } from "../types/unsuitableReason.types";

export const UNSUITABLE_REASON_KEYS = {
  pressList: "PRESS_LIST",
  pressDetail: "PRESS_DETAIL",
  ctgList: "CTG_LIST",
  ctgDetail: "CTG_DETAIL",
  regulatoryList: "REGULATORY_LIST",
  regulatoryDetail: "REGULATORY_DETAIL",
  publicationList: "PUBLICATION_LIST",
  publicationDetail: "PUBLICATION_DETAIL",
  patentList: "PATENT_LIST",
  patentDetail: "PATENT_DETAIL",
} as const;

export const TOAST_POSITION_BY_USAGE_TYPE: Record<
  UnsuitableReasonUsageType,
  "topCenter" | "bottomLeft"
> = {
  [UNSUITABLE_REASON_KEYS.pressList]: "bottomLeft",
  [UNSUITABLE_REASON_KEYS.ctgList]: "bottomLeft",
  [UNSUITABLE_REASON_KEYS.publicationList]: "bottomLeft",
  [UNSUITABLE_REASON_KEYS.pressDetail]: "topCenter",
  [UNSUITABLE_REASON_KEYS.ctgDetail]: "topCenter",
  [UNSUITABLE_REASON_KEYS.regulatoryList]: "bottomLeft",
  [UNSUITABLE_REASON_KEYS.regulatoryDetail]: "topCenter",
  [UNSUITABLE_REASON_KEYS.publicationDetail]: "topCenter",
  [UNSUITABLE_REASON_KEYS.patentList]: "bottomLeft",
  [UNSUITABLE_REASON_KEYS.patentDetail]: "topCenter",
};

export const LIST_USAGE_TYPES: UnsuitableReasonUsageType[] = [
  UNSUITABLE_REASON_KEYS.pressList,
  UNSUITABLE_REASON_KEYS.ctgList,
  UNSUITABLE_REASON_KEYS.publicationList,
  UNSUITABLE_REASON_KEYS.regulatoryList,
  UNSUITABLE_REASON_KEYS.patentList,
];

export const MODAL_POSITION_BY_USAGE_TYPE: Record<
  UnsuitableReasonUsageType,
  { top: string; left: string; right: string; bottom: string }
> = {
  [UNSUITABLE_REASON_KEYS.pressList]: {
    top: "100%",
    left: "auto",
    right: "0",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.ctgList]: {
    top: "103%",
    left: "-150%",
    right: "auto",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.publicationList]: {
    top: "101%",
    left: "-150%",
    right: "auto",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.regulatoryList]: {
    top: "101%",
    left: "-150%",
    right: "auto",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.pressDetail]: {
    top: "100%",
    left: "auto",
    right: "0",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.ctgDetail]: {
    top: "100%",
    left: "auto",
    right: "0",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.regulatoryDetail]: {
    top: "100%",
    left: "auto",
    right: "0",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.publicationDetail]: {
    top: "100%",
    left: "auto",
    right: "0",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.patentList]: {
    top: "101%",
    left: "-150%",
    right: "auto",
    bottom: "auto",
  },
  [UNSUITABLE_REASON_KEYS.patentDetail]: {
    top: "100%",
    left: "auto",
    right: "0",
    bottom: "auto",
  },
};
